var _this = this;

var origin = function origin(o) {
    return o;
};
var noop = function noop() {};
var isFunction = function isFunction(fn) {
    return typeof fn === 'function';
};
var callbackNames = ['success', 'fail', 'complete'];
var nameSpaces = ['wechat', 'h5'];
var wechatMsgReg = /\:(ok|cancel)$/;

var getCallback = function getCallback(options, debug) {
    options = options || {};
    var successCb = options.success,
        failCb = options.fail,
        completeCb = options.complete,
        hooks = options.hooks,
        self = _this;
    delete options.success;
    delete options.fail;
    delete options.complete;
    delete options.hooks;
    return function (data) {
        debug && console.info('[HySDK] Hy Callback Data:', data);
        if (!data || typeof data.ret === 'undefined') {
            isFunction(successCb) && successCb(data);
            isFunction(hooks) && hooks(self, options, data);
        } else if (data.ret) {
            isFunction(successCb) && successCb(data.data);
            isFunction(hooks) && hooks(self, options, data.data);
        } else {
            isFunction(failCb) && failCb(data);
        }
        isFunction(completeCb) && completeCb(data);
    };
};

var handleCb = function handleCb(options, conf, debug) {
    options = options || {};
    callbackNames.forEach(function (name) {
        if (options[name]) {
            var fn = options[name],
                handle = conf[name + 'Handle'] || origin;
            options[name] = function (data) {
                debug && console.info('[HySDK] Wechat ' + name + ' Data:', data);
                if (!wechatMsgReg.test(data.errMsg)) {
                    data.message = data.errMsg;
                }
                delete data.errMsg;
                return fn(handle(data));
            };
        }
    });
};

var fixOptionsCallback = function fixOptionsCallback(options) {
    options = options || {};
    var successCb = options.success || noop,
        failCb = options.fail || noop,
        completeCb = options.complete || noop;

    options.success = function (data) {
        successCb(data);
        completeCb(data);
    };
    options.fail = function (data) {
        failCb(data);
        completeCb(data);
    };
    return options;
};

var setUpFunction = function setUpFunction(sdk, key, conf, debug, timeout) {
    var obj = fns[key] = fns[key] || {};
    if (conf.wechat) {
        var cf = conf.wechat,
            bridgeName = cf.key || key,
            optHandle = cf.optHandle || origin,
            handle = cf.handle || null;
        obj.wechat = function (options) {
            if (handle) {
                return handle(options, sdk);
            }
            var opt = optHandle.call(sdk, options);
            handleCb(options, cf);
            debug && console.log('[HySDK] ENV => wechat, Key => ' + key + ', BridgeName => ' + bridgeName + ', options => ', opt);
            return sdk.bridge[bridgeName](opt);
        };
    }
    if (conf.h5) {
        var _cf = conf.h5,
            _handle = _cf.handle;
        obj.h5 = function (options) {
            debug && console.log('[HySDK] ENV => h5, Key => ' + key, options);
            return _handle(options, sdk);
        };
    }
    // hy 或自定义命名空间
    if (conf.hy || conf.namespace && nameSpaces.indexOf(conf.namespace) === -1) {
        var _cf2 = {},
            namespace = null,
            _bridgeName = null;
        if (conf.hy && typeof conf.hy !== 'boolean') {
            _cf2 = conf.hy;
            namespace = 'hy';
            _bridgeName = _cf2.key || key;
        }
        if (conf.namespace) {
            _cf2 = conf;
            namespace = conf.namespace;
            _bridgeName = conf.bridge || key;
        }
        var _optHandle = _cf2.optHandle || origin,
            resHandle = _cf2.resHandle || origin,
            hooks = _cf2.hooks || null;

        obj[namespace] = function (options) {
            if (hooks) {
                options.hooks = hooks;
            }
            var callback = getCallback.call(sdk, options),
                opt = _optHandle.call(sdk, options) || {},
                through = true,
                timer = void 0;
            debug && console.log('[HySDK] ENV => hy, Key => ' + key + ', BridgeName => ' + _bridgeName + ', options => ', opt);
            if (opt.timeout) {
                if (typeof opt.timeout === 'number') {
                    timeout = opt.timeout;
                }
                timer = setTimeout(function () {
                    through = false;
                    timer = null;
                    callback({
                        ret: false,
                        errmsg: 'Api Timeout',
                        errcode: 10010
                    });
                }, timeout);
            } else if (opt.timeout === 0) {
                delete opt.timeout;
            }
            return sdk.bridge.invoke(_bridgeName, function (data) {
                if (through) {
                    if (timer) {
                        clearTimeout(timer);
                        timer = null;
                    }
                    return callback(resHandle(data));
                }
            }, opt);
        };
    }
};

var bind = function bind(sdk, key, env) {
    var process = function process(options) {
        var fn = fns[key][env];
        return fn.call(sdk, options);
    };
    if (nameSpaces.indexOf(env) === -1) {
        return function (options) {
            return sdk.isReady ? sdk.env === 'hy' && process(options) : sdk.ready(function () {
                return sdk.env === 'hy' && process(options);
            });
        };
    }
    return function (options) {
        return sdk.isReady ? sdk.env === env && process(options) : sdk.ready(function () {
            return sdk.env === env && process(options);
        });
    };
};

var common = function common(sdk, key, debug) {
    var process = function process(options) {
        var fn = fns[key][sdk.env];
        if (fn) {
            return fn.call(sdk, options);
        } else {
            //TODO 考虑是否应该报 warn
            getCallback(options)({
                ret: false,
                errcode: 10001,
                errmsg: 'API not support'
            });
            debug && console.warn('[HySDK] ' + sdk.env + ' not support "' + key + '"!');
        }
    };

    return function (options) {
        return sdk.isReady ? process(options) : sdk.ready(function () {
            return process(options);
        });
    };
};

var fns = {};

module.exports = {
    setUpFunction: setUpFunction,
    bind: bind,
    common: common,
    fns: fns
};


//////////////////
// WEBPACK FOOTER
// ../src/register.js
// module id = 25
// module chunks = 0 2 4